export { default as Img200 } from './processed/200/Buried-Knights-Templar-1.jpg';
export { default as Img400 } from './processed/400/Buried-Knights-Templar-1.jpg';
export { default as Imgthumb } from './processed/thumb/Buried-Knights-Templar-1.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Buried-Knights-Templar-1.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Buried-Knights-Templar-1.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      111,
      148,
      187
    ],
    "_population": 1511,
    "_hsl": [
      0.5855263157894737,
      0.3584905660377358,
      0.584313725490196
    ]
  },
  "LightVibrant": {
    "_rgb": [
      161,
      196,
      220
    ],
    "_population": 189,
    "_hsl": [
      0.5677966101694915,
      0.45736434108527146,
      0.7470588235294118
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      43,
      66,
      90
    ],
    "_population": 0
  },
  "Muted": {
    "_rgb": [
      98,
      135,
      174
    ],
    "_population": 341,
    "_hsl": [
      0.5855263157894737,
      0.31932773109243695,
      0.5333333333333333
    ]
  },
  "LightMuted": {
    "_rgb": [
      159,
      183,
      198
    ],
    "_population": 2067,
    "_hsl": [
      0.5641025641025641,
      0.2549019607843137,
      0.7
    ]
  },
  "DarkMuted": {
    "_rgb": [
      77,
      62,
      53
    ],
    "_population": 705,
    "_hsl": [
      0.06249999999999999,
      0.18461538461538457,
      0.2549019607843137
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Buried-Knights-Templar-1.js